export class RequestError extends Error {
  constructor(status, responseBody, ...params) {
    super(...params);
    this.name = 'RequestError';
    this.status = status;
    this.responseBody = responseBody;
  }
}
